// ContextVars.js
import React, { createContext, useState, useEffect } from 'react';

// Create context
export const AppContext = createContext();

// Context provider
export const AppProvider = ({ children }) => {
  const [totalAmount, setTotalAmount] = useState(0);
  const [totalAmountGTQ, setTotalAmountGTQ] = useState(0); // #added 11/5/25 TG
  const [purchaseDescription, setPurchaseDescription] = useState(''); // #added 23/5/25 TG
  const [cart, setCart] = useState([]);
  const [testMode, setTestMode] = useState(false); // #testmode para poder probar lo que todavía no está live va vos TG #added 20/7/25 TG
  const [language, setLanguage] = useState('es'); // #idioma ES/EN TG
  const siteVersion = "14.8.25 TG"; // #added 14/8/25 TG

  // 🛒 Move and define addToCart here
  const addToCart = (product) => {
    // product is expected to be an object like:
    // { name: 'Plan A', amount: 20, amountGTQ: 160 }

    setCart(prevCart => [...prevCart, product]);
    // setTotalAmount(totalAmount + parseFloat(product.price));
    // setTotalAmountGTQ(totalAmountGTQ + parseFloat(product.pricegtq));
    // navigate('/checkout');
  };

  const buyNow = (product, navigate) => {
    // product is expected to be an object like:
    // { name: 'Plan A', amount: 20, amountGTQ: 160 }

    setCart(prevCart => [...prevCart, product]);
    // setTotalAmount(totalAmount + parseFloat(product.price));
    // setTotalAmountGTQ(totalAmountGTQ + parseFloat(product.pricegtq));
    navigate('/checkout');
  };

  // #CART TG
  useEffect(() => {
    console.log("cart:", cart);
    updateTotals();
  }, [cart]);

  // #Total
  useEffect(() => { // #added esto el 20/7/25 TG
    console.log("total amount: ", totalAmount);
    console.log("total amount GTQ: ", totalAmountGTQ);
  }, [totalAmount, totalAmountGTQ]);

  const updateTotals = () => {
    const tusd = cart.reduce((sum, item) => sum + parseFloat(item.price || 0), 0);
    const tgtq = cart.reduce((sum, item) => sum + parseFloat(item.pricegtq || 0), 0)
    setTotalAmount(tusd);
    setTotalAmountGTQ(tgtq);
  }

      useEffect(() => {
        if (testMode) {
          console.log("#TESTMODE ACTIVATED, BOOM! YOU'RE A MAGNIFIQUE CODER!")
        }
      }, [testMode]);

  return (
    <AppContext.Provider 
      value={{
        totalAmount,
        setTotalAmount,
        totalAmountGTQ,
        setTotalAmountGTQ,
        purchaseDescription,
        setPurchaseDescription,
        cart,
        setCart,
        addToCart,
        buyNow,
        testMode,
        setTestMode,
        language,
        setLanguage,
        siteVersion
      }}
    >
      {children}
    </AppContext.Provider>
  );
};